// extracted by mini-css-extract-plugin
export var countriesList = "EligibleCountries--countriesList--wE70c";
export var countriesList__container = "EligibleCountries--countriesList__container--n+JvU";
export var countriesList__content = "EligibleCountries--countriesList__content--0QaCa";
export var tkMyriadProSemiCondensed = "EligibleCountries--tk-myriad-pro-semi-condensed--Oda6n";